import {
  SEDE_ROUTES,
  sedeListResponseSchema,
  sedeResponseSchema,
  type Sede,
  type SedeInput,
  type SedeListQuery,
  type SedeUpdate,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/**
 * Las sedes del panel (réplica de `manage-sedes` de producción): el
 * origen de los envíos cuando entre Trasso. `baseUrl: ""` porque las
 * rutas del contrato ya traen `/api`.
 */
const NO_PREFIX = { baseUrl: "" } as const;

export interface SedePage {
  items: Sede[];
  total: number;
  page: number;
  perPage: number;
}

/** Filtros y paginación EN LA URL: el servidor devuelve solo la página. */
export function listSedes(query: SedeListQuery): Promise<SedePage> {
  const params = new URLSearchParams();
  params.set("page", String(query.page));
  params.set("perPage", String(query.perPage));
  if (query.query) params.set("query", query.query);
  if (query.status) params.set("status", query.status);
  return authFetch(
    `${SEDE_ROUTES.adminList}?${params.toString()}`,
    sedeListResponseSchema,
    NO_PREFIX,
  );
}

export async function createSede(input: SedeInput): Promise<Sede> {
  const data = await authFetch(SEDE_ROUTES.adminCreate, sedeResponseSchema, {
    ...NO_PREFIX,
    method: "POST",
    body: input,
  });
  return data.sede;
}

export async function updateSede(id: string, update: SedeUpdate): Promise<Sede> {
  const data = await authFetch(SEDE_ROUTES.adminOne(id), sedeResponseSchema, {
    ...NO_PREFIX,
    method: "PATCH",
    body: update,
  });
  return data.sede;
}
